import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { CultureEditService } from '../../service/culture-edit/culture-edit.service';

@Component({
	selector: 'app-culture-edit',
	templateUrl: './culture-edit.component.html',
	providers: [
		CultureEditService,
		HttpModule
	]
})
export class CultureEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	culture: FormGroup;
	ID: string;
	Descricao: string;
	UnidadeMedida:string;
	Ativo: boolean;

	constructor(fb: FormBuilder, private cultureEditService: CultureEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.culture = fb.group({
			'ID': '',
			'Descricao': ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
			'UnidadeMedida': ['', Validators.compose([Validators.required, Validators.maxLength(10)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.cultureEditService.loadCulture(this.token, this.ID).subscribe(result => {
				var updateCulture = result.Result;
				this.culture.setValue({
					ID: updateCulture.ID,
					Descricao: updateCulture.Descricao,
					UnidadeMedida:updateCulture.UnidadeMedida,
					Ativo: updateCulture.Ativo
				});
			})
		}, error => {
			console.log(error);

		});
	}

	editCulture(value: any) {
		console.log("cultura",value);
		this.cultureEditService.editCulture(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Cultura editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/cultura');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/cultura');
	}

}



// WEBPACK FOOTER //
// ./src/app/culture/component/culture-edit/culture-edit.component.ts